import { RoleSelectionWidget, UserCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  role_id: {
    'ui:widget': RoleSelectionWidget,
  },
  user_category_ids: {
    'ui:widget': UserCategorySelectionWidget,
  },
});

export default uiSchema;
